import { render, staticRenderFns } from "./student-achievement-main.vue?vue&type=template&id=f11432cc"
import script from "./student-achievement-main.vue?vue&type=script&lang=js"
export * from "./student-achievement-main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports